import React from 'react';

import Fields from '~components/form-fields/Fields';
import Modal from '~components/Modal';

import fields from '~support-at-home/forms/budgets/budgetDetails';

interface ComponentProps {
  isOpen?: boolean;
  setIsOpen: (toggle: boolean) => void;
  values: any;
  onChange?: (name: string, value: any) => void;
}

const BudgetDetailsModal: React.FC<ComponentProps> = ({ isOpen, setIsOpen, values, onChange }) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} header="Edit Budget Details" size="lg" headerClassName="header">
      <Fields definitions={fields} values={values} setFieldValue={onChange} setFieldTouched={() => null} />
    </Modal>
  );
};

export default BudgetDetailsModal;
